import React, { useEffect, useState } from 'react';
import { motion, useMotionValue, useReducedMotion, useSpring } from 'framer-motion';
interface CaseStudyCursorProps {
  isActive: boolean;
  x: ReturnType<typeof useMotionValue<number>>;
  y: ReturnType<typeof useMotionValue<number>>;
}
export function CaseStudyCursor({
  isActive,
  x,
  y
}: CaseStudyCursorProps) {
  const prefersReducedMotion = useReducedMotion();
  const [supportsHover, setSupportsHover] = useState(false);
  const springX = useSpring(x, {
    stiffness: 320,
    damping: 32,
    mass: 0.4
  });
  const springY = useSpring(y, {
    stiffness: 320,
    damping: 32,
    mass: 0.4
  });
  useEffect(() => {
    const query = window.matchMedia('(hover: hover) and (pointer: fine)');
    setSupportsHover(query.matches);
    const handleChange = () => setSupportsHover(query.matches);
    query.addEventListener('change', handleChange);
    return () => query.removeEventListener('change', handleChange);
  }, []);
  if (prefersReducedMotion || !supportsHover) {
    return null;
  }
  return <motion.div aria-hidden="true" style={{
    left: springX,
    top: springY
  }} animate={{
    opacity: isActive ? 1 : 0,
    scale: isActive ? 1 : 0.85
  }} transition={{
    duration: 0.2,
    ease: [0.23, 1, 0.32, 1]
  }} className="pointer-events-none absolute z-30 flex h-24 w-24 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-ink text-center text-[13px] font-medium leading-tight text-white" data-id="element-450" data-mp="y11tl2kimnkx">
      View case
      <br data-id="element-451" data-mp="1gyco69v7csu1" />
      study
    </motion.div>;
}